// Combined hook to manage expert report fetching together with a selected version state
import { useEffect, useState } from 'react';
import { useExpertReport, useExpertReportVersionState } from './api/hooks';

export const useExpertReportWithVersion = (id?: number | string) => {
  const [customVersion, setCustomVersion] = useState<number | undefined>();

  const { data: baseReport, isLoading: isLoadingReport } = useExpertReport(id);

  const currentVersionId = baseReport?.currentVersion.id;
  const effectiveVersionId = customVersion === currentVersionId ? undefined : customVersion;

  const { data: versionReport, isLoading: isLoadingVersion } = useExpertReportVersionState(effectiveVersionId);

  const isLoading = isLoadingReport || isLoadingVersion;
  const isLastVersion = !customVersion || customVersion === currentVersionId;
  const selectedReport = isLastVersion ? baseReport : versionReport;

  useEffect(() => {
    if (typeof currentVersionId === 'number') {
      setCustomVersion(currentVersionId);
    }
  }, [currentVersionId]);

  return {
    selectedReport,
    versionReport: customVersion
      ? {
          ...versionReport,
          versionId: customVersion,
        }
      : undefined,
    baseReport,
    isLoading,
    isLastVersion,
    versionId: customVersion ?? currentVersionId,
    setVersion: setCustomVersion,
  } as const;
};
